import { HStack, IconButton, useColorModeValue } from '@chakra-ui/react';
import { LayoutGrid, LayoutList } from 'lucide-react';
import { Icon } from '@chakra-ui/react';
import type { ViewModeToggleProps } from '../dashboard.types';

/**
 * View Mode Toggle Component
 * Toggles between "Cards" and "Table" views (Rocks view only)
 */
export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  const activeBg = useColorModeValue('blue.100', 'blue.900');
  const activeColor = 'blue.600';
  const inactiveColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.300', 'gray.600');
  const hoverBg = useColorModeValue('gray.100', 'gray.700');

  return (
    <HStack spacing={0} borderLeftWidth="1px" borderColor={borderColor} pl={3}>
      <IconButton
        aria-label="Card View"
        icon={<Icon as={LayoutGrid} w={5} h={5} />}
        variant={value === 'cards' ? 'solid' : 'ghost'}
        colorScheme={value === 'cards' ? 'blue' : undefined}
        bg={value === 'cards' ? activeBg : 'transparent'}
        color={value === 'cards' ? activeColor : inactiveColor}
        onClick={() => onChange('cards')}
        size="sm"
        _hover={{
          bg: value === 'cards' ? activeBg : hoverBg,
        }}
      />
      <IconButton
        aria-label="Table View"
        icon={<Icon as={LayoutList} w={5} h={5} />}
        variant={value === 'table' ? 'solid' : 'ghost'}
        colorScheme={value === 'table' ? 'blue' : undefined}
        bg={value === 'table' ? activeBg : 'transparent'}
        color={value === 'table' ? activeColor : inactiveColor}
        onClick={() => onChange('table')}
        size="sm"
        _hover={{
          bg: value === 'table' ? activeBg : hoverBg,
        }}
      />
    </HStack>
  );
}

